<template>
    <el-dialog :title="title" :visible.sync="visible" width="500px" :close-on-click-modal="false">
        <Language :add="add" v-model="form.lang" style="margin-top: -20px" @change="handleLangChange"></Language>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item v-if="form.name === 'contact_code'" label="" prop="value">
                <Uploader v-model="form.value"></Uploader>
            </el-form-item>
            <el-form-item v-else label="电话" prop="value">
                <el-input v-model="form.value" placeholder="请输入电话"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="handleConfirm">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Uploader from "@/components/Uploader";
import Language from "@/components/Language";
import { edit, detail } from "@/api/content/contact";
export default {
    components: { Language, Uploader },
    data() {
        return {
            visible: false,
            title: "新增分类",
            form: {
                name: "",
                value: "",
            },
            rules: {},
            add: true,
        };
    },
    methods: {
        open(row) {
            this.visible = true;
            if (row.name === "contact_code") {
                this.title = "更新客服二维码";
            } else {
                this.title = "更新电话";
            }
            this.form.name = row.name;
            this.form.lang = "zh";
            this.getDetail();
        },
        handleLangChange() {
            this.getDetail();
        },
        getDetail() {
            detail({ name: this.form.name, lang: this.form.lang }).then(({ code, result, error }) => {
                if (code === 200) {
                    if (result) {
                        this.form.value = result.value;
                        this.add = false;
                    } else {
                        this.add = true;
                        this.form.value = "";
                        this.$nextTick(() => {
                            this.$refs.form.clearValidate();
                        });
                    }
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    ...this.form,
                };
                edit(params).then(({ code, error }) => {
                    if (code === 200) {
                        this.$message.success("更新成功");
						this.visible = false;
                        this.$emit("update");
                    } else {
                        this.$message.error(error.message);
                    }
                });
            });
        },
    },
};
</script>

<style></style>
